<template>
  <b-navbar fixed-top>
    <template slot="brand">
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <h1 class="subtitle has-text-info">ReadSE</h1>
      </b-navbar-item>
    </template>
    <template slot="start">
      <b-navbar-item href="#/texts">
        Texts
      </b-navbar-item>
      <b-navbar-item href="#/documentrepos">
        Documents Repositories
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>

export default {
  name: 'Navbar',
};
</script>

<style scoped>

</style>
